import { render, staticRenderFns } from "./AccommodationListPartial.vue?vue&type=template&id=165656a6&scoped=true&"
import script from "./AccommodationListPartial.vue?vue&type=script&lang=js&"
export * from "./AccommodationListPartial.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationListPartial.vue?vue&type=style&index=0&id=165656a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165656a6",
  null
  
)

export default component.exports